import type { IconData } from '@stacksjs/iconify-core'

export const notificationEmail: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 1.53h-1.52V0h-4.57v1.53h-1.52v1.52h-1.53v4.57h1.53v1.53h1.52v1.52h4.57V9.15h1.52V7.62H32V3.05h-1.53Zm-3.04 7.62H25.9V7.62h1.53Zm0-3.05H25.9V1.53h1.53Zm0 9.14h1.52v15.24h-1.52ZM1.52 30.48h25.91V32H1.52Zm18.29-13.71v6.09h6.09v-6.09Zm4.57 4.57h-3.05v-3.05h3.05ZM3.05 27.43h10.66v1.53H3.05ZM7.62 4.58h12.19V6.1H7.62Zm13.71 6.09V9.15H7.62V6.1H6.09v3.05H4.57v1.52zM3.05 22.86h6.09v1.52H3.05Zm24.38-7.62v-1.52H25.9v-1.53h-1.52v1.53H4.57v-3.05H3.05v3.05H1.52v1.52zM0 15.24h1.52v15.24H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default notificationEmail
